import axios from 'axios';
import { useState, useEffect, useRef } from 'react';
import { BiSolidCheckCircle } from "react-icons/bi";
import { changeMarketData } from '../../common/utils';

export default function MarketStep1({
	selectedData,
	getMarket,
	getMarketID,
	getTaskName,
}) {
	const qs = require('qs');
	const [MarketIdRadioList, setMarketIdRadio] = useState([]);
	const [marketRadioList, setMarketRadio] = useState([]);

	const handleMarketChange = (e) => {
		const newValue = e.target.value;
		getMarket(newValue);
		// 마켓별 마켓 아이디 요청API
		axios
			.post(
				`${window.location.protocol}//${window.location.hostname}:3001/getAccount`,
				qs.stringify({
					token: localStorage.getItem('token'),
					marketCode: newValue
				})
			)
			.then((res) => {
				setMarketIdRadio(res.data.map(m => m.loginId));
			})
			.catch();
	};
	const handleMarketIDChange = (e) => {
		const newValue = e.target.value;
		getMarketID(newValue);
	};
	const handleTaskNameChange = (e) => {
		const newValue = e.target.value;
		console.log('newValue: ', newValue);
		getTaskName(newValue);
	};
	useEffect(() => {
		axios
			.post(
				`${window.location.protocol}//${window.location.hostname}:3001/getMarket`,
				qs.stringify({
					token: localStorage.getItem('token')
				})
			)
			.then((res) => {
				setMarketRadio(res.data.map(m => { return { label: changeMarketData(m), value: m } }));
			})

		if (selectedData.market) {
			// 마켓별 마켓 아이디 요청API
			axios
				.post(
					`${window.location.protocol}//${window.location.hostname}:3001/getAccount`,
					qs.stringify({
						token: localStorage.getItem('token'),
						marketCode: selectedData.market
					})
				)
				.then((res) => {
					setMarketIdRadio(res.data.map(m => m.loginId));
				})
				.catch();
		}
	}, []);

	return (
		<>
			<h3><span className={selectedData.market ? 'on' : ''}><BiSolidCheckCircle /></span>마켓 선택</h3>
			<div className='radioItem'>
				{marketRadioList.map((el, index) => (
					<label key={index} className={selectedData.market === el.value ? 'on' : ''}>
						<input
							type='radio'
							name='market'
							value={el.value || ''}
							onChange={handleMarketChange}
							checked={selectedData.market && selectedData.market === el.value}
						/>
						<span>{el.label}</span>
					</label>
				))}
			</div>
			<h3><span className={selectedData.marketID ? 'on' : ''}><BiSolidCheckCircle /></span>마켓 아이디 선택</h3>
			<div className='radioItem'>
				{(MarketIdRadioList.length > 0 || selectedData) &&
					MarketIdRadioList.map((el, index) => (
						<label key={index} className={selectedData.marketID === el ? 'on' : ''}>
							<input
								type='radio'
								name='marketID'
								value={el || ''}
								onChange={handleMarketIDChange}
								checked={selectedData.marketID && selectedData.marketID === el}
							/>
							<span>{el}</span>
						</label>
					))}
			</div>
			<h3><span className={selectedData.taskName ? 'on' : ''}><BiSolidCheckCircle /></span>작업줄명</h3>
			<input
				type='text'
				placeholder=''
				value={selectedData && selectedData.taskName}
				onChange={handleTaskNameChange}
			/>
		</>
	);
}
